import "./Venues.scss";

import { useEffect, useState } from "react";
import { MdEdit } from "react-icons/md";
import {Link, useNavigate} from "react-router-dom";

import SideBar from "../../components/SideBar/SideBar";
import TableColumn from "../../components/TableColumn/TableColumn";
import TopNav from "../../components/TopNav/TopNav";
import api from "../../services/api";
import Button from "../../components/Buttons/Button";
import { colors } from "../../styles/tokens";

function Venues({ market = "miami" }) {
  const navigate = useNavigate();

  // Miami keeps the legacy storage key so admins don't lose their page.
  const pageStorageKey =
    market === "nyc" ? "ListCurrentPageNycVenues" : "ListCurrentPageBusiness";
  const title = market === "nyc" ? "NYC Venues" : "Miami Venues";

  const [venues, setVenues] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem(pageStorageKey)) || 1
  );
  const records = 10;

  const [searchTerm, setSearchTerm] = useState("");

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("null");

  // NYC-only: Manhattan/Brooklyn share the nyc market tab, distinguished by
  // the venue's `borough` field (legacy rows with none are Manhattan).
  const [boroughFilter, setBoroughFilter] = useState("all");

  useEffect(() => {
    const getVenues = async (page) => {
      try {
        // /venues (admin list) handles name search + market filter itself.
        // /venues/search is app-facing and hides inactive rows, which would
        // hide every staged NYC venue.
        const response = await api.get(`/venues`, {
          params: {
            records: records,
            page: page,
            sort_column: sortBy,
            sort: sortDirection,
            market: market,
            ...(market === "nyc" && boroughFilter !== "all" ? { borough: boroughFilter } : {}),
            ...(searchTerm ? { name: searchTerm } : {}),
          },
        });
        const formattedVenues = response.data.data.map((venue) => ({
          Image: (
            <img
              className="rounded"
              style={{ height: 40, width: 40, objectFit: "cover" }}
              src={venue.image_urls?.[0] || ""}
              alt={venue.name}
            />
          ),
          Name: venue.name,
          id: venue._id,
          // "Working time": getCurrentDayHours(venue.hours),
          Email: venue.email,
          Location: venue.address,
          About: venue.description,
          Website: venue.url,
          Likes: (
        <Link to={`/venue/followers/${venue._id}`} className="number-pill">
          {venue.followers}
        </Link>
      ),
          Phone: venue.phone || "—",
        }));

        console.log(formattedVenues)

        setVenues(formattedVenues);
        setTotalPages(response.data.total);
      } catch (error) {
        console.log(`venues get request didn't work. error: ${error}`);
      }
    }

    getVenues(currentPage)
  }, [navigate, currentPage, sortBy, sortDirection, searchTerm, market, boroughFilter]);


  const fetchAllData = async () => {
    try {
      const response = await api.get(`/venues`, {
        params: {
          records: 9999999999,
          market: market,
          ...(market === "nyc" && boroughFilter !== "all" ? { borough: boroughFilter } : {}),
        },
      });


      return response.data.data.map((venue) => ({
        Name: venue.name,
        id: venue._id,
        // "Working time": getCurrentDayHours(venue.hours),
        Email: venue.email,
        Location: venue.address,
        About: venue.description,
        Website: venue.url,
        Followers: (
            <Link to={`/venue/followers/${venue._id}`} className="number-pill">
              {venue.followers}
            </Link>
        ),
        "Check Ins": venue.check_ins,
      }));

    } catch (error) {
      console.log(`Error fetching all data: ${error}`);
      return [];
    }
  };


  const columns = [
    "Image",
    "Name",
    // "Working time",
    "Email",
    "Phone",
    "Location",
    "Website",
    // "Price",
    "About",
    "Likes",
  ];

  const sortableColumns = ["Name", "Email", "Phone", "Website", "Location"];

  const actions = [
    {
      label: <MdEdit size={30} color={colors.primary} />,
      onClick: (rowData) => {
        console.log(rowData);
        navigate(`/business/edit/${rowData.id}`);
      },
    },
  ];



  const handleChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setCurrentPage(0);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem(pageStorageKey, page);
  };

  const handleBoroughChange = (event) => {
    setBoroughFilter(event.target.value);
    setCurrentPage(1);
  };



  useEffect(() => {
    const storedPage = localStorage.getItem(pageStorageKey);

    setCurrentPage(Number(storedPage) || 1);
  }, [pageStorageKey]);


  const sortColumnsMapping = {
    Name: "name",
    Email: "email",
    Phone: "phone",
    Website: "url",
    Location: "address",
  };

  const handleSort = (columnName) => {
    const backendColumnName = sortColumnsMapping[columnName];
    if (sortBy === backendColumnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumnName);
      setSortDirection("asc");
    }
  };


  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section className="venues">
            {market === "nyc" && (
              <div className="venues__borough-filter">
                <select value={boroughFilter} onChange={handleBoroughChange}>
                  <option value="all">All boroughs</option>
                  <option value="manhattan">Manhattan</option>
                  <option value="brooklyn">Brooklyn</option>
                </select>
              </div>
            )}
            <TableColumn
              title={title}
              columns={columns}
              data={venues}
              sortableColumns={sortableColumns}
              hasExport={true}
              hasSearch={true}
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              records={records}
              actions={actions}
              customButton={
                <Button
                  style={{ paddingBottom: "18px", paddingTop: "18px" }}
                  label="Add new venue +"
                  onClick={() => navigate(`/business/add?market=${market}`)}
                  primaryBtn
                />
              }
              inputSearchProps={{ value: searchTerm, onChange: handleChange }}
              fetchAllData={fetchAllData}


              onSort={handleSort}

            />
          </section>
        </article>
      </div>
    </main>
  );
}

export default Venues;
